import React from "react";
import { Navigate } from "react-router-dom";

// Unused fallback - handled inline in AuthCallback now
const RoleSelect = () => <Navigate to="/login" replace />;
export default RoleSelect;
